/**
 * specieLookup mixin
 * Metodi di traversal sull'albero specie/serie/varietà e generazione opzioni.
 * Richiede che il componente esponga: specie_disponibili (Array)
 */
export default {
  methods: {
    nomeSpecieList(idsSpecie) {
      return (idsSpecie || []).map((idSpecie) => {
        const specie = this.specie_disponibili.find((item) => item.id === idSpecie);
        return specie ? specie.nome : `ID ${idSpecie}`;
      });
    },

    nomeSerie(idSpecie, idSerie) {
      if (!idSpecie || !idSerie) return null;
      const specie = this.specie_disponibili.find((item) => item.id == idSpecie);
      if (!specie || !Array.isArray(specie.series)) return null;
      const serie = specie.series.find((item) => item.id == idSerie);
      return serie ? serie.nome : `Serie ${idSerie}`;
    },

    nomeVarieta(idSpecie, idVarieta) {
      if (!idSpecie || !idVarieta) return null;
      const specie = this.specie_disponibili.find((item) => item.id == idSpecie);
      if (!specie || !Array.isArray(specie.variety)) return null;
      const varieta = specie.variety.find((item) => item.id == idVarieta);
      return varieta ? varieta.nome : `Varietà ${idVarieta}`;
    },

    descrizioneComponenti(componenti) {
      return (componenti || [])
        .map((componente) => {
          const nomeSpecie = this.nomeSpecieList([componente.id_specie])[0] || "Specie";
          const nomeSerie = this.nomeSerie(componente.id_specie, componente.id_serie);
          const nomeVar = this.nomeVarieta(componente.id_specie, componente.id_varieta);
          if (nomeSerie && nomeVar) return `${nomeSpecie} - ${nomeSerie} - ${nomeVar}`;
          if (nomeSerie)           return `${nomeSpecie} - ${nomeSerie}`;
          if (nomeVar)             return `${nomeSpecie} - ${nomeVar}`;
          return nomeSpecie;
        })
        .join("\n");
    },

    serieOptions(idSpecie) {
      if (!idSpecie) return [];
      const specie = this.specie_disponibili.find((item) => item.id == idSpecie);
      if (!specie || !Array.isArray(specie.series)) return [];
      return specie.series.map((serie) => ({
        value: serie.id,
        text: serie.nome || `Serie ${serie.id}`,
      }));
    },

    varietaOptions(idSpecie, idSerie) {
      if (!idSpecie) return [];
      const specie = this.specie_disponibili.find((item) => item.id == idSpecie);
      if (!specie || !Array.isArray(specie.variety)) return [];

      const filtered = specie.variety.filter((varieta) => {
        if (!idSerie) return true;
        if (Array.isArray(varieta.serie)) return varieta.serie.includes(idSerie);
        return varieta.serie == idSerie || varieta.id_serie == idSerie;
      });

      return filtered.map((varieta) => ({
        value: varieta.id,
        text: varieta.nome,
        img_url: `${process.env.VUE_APP_API_ROOT}/specie/img_colore/${varieta.id_colore}?t=${varieta.md5_colore || ""}`,
      }));
    },

    findVarietaById(idSpecie, idVarieta) {
      if (!idSpecie || !idVarieta) return null;
      const specie = this.specie_disponibili.find((item) => item.id == idSpecie);
      if (!specie || !Array.isArray(specie.variety)) return null;
      return specie.variety.find((varieta) => varieta.id == idVarieta) || null;
    },

    getComponentiDettaglio(prodotto) {
      const counts = {};
      const ordered = [];

      (prodotto.componenti || [])
        .filter((c) => !!c.id_specie)
        .forEach((componente) => {
          const specie = this.specie_disponibili.find((s) => s.id == componente.id_specie);
          const varieta = specie && Array.isArray(specie.variety) && componente.id_varieta
            ? specie.variety.find((v) => v.id == componente.id_varieta)
            : null;
          const nomeSpecie = specie ? specie.nome : `ID ${componente.id_specie}`;
          const nomeVar = varieta ? varieta.nome : null;
          const nomeSerie = this.nomeSerie(componente.id_specie, componente.id_serie);
          const label = nomeSerie && nomeVar ? `${nomeSpecie} - ${nomeSerie} - ${nomeVar}`
            : nomeSerie                      ? `${nomeSpecie} - ${nomeSerie}`
            : nomeVar                        ? `${nomeSpecie} - ${nomeVar}`
            : nomeSpecie;
          const img_url = varieta
            ? `${process.env.VUE_APP_API_ROOT}/specie/img_colore/${varieta.id_colore}?t=${varieta.md5_colore || ""}`
            : specie
              ? `${process.env.VUE_APP_API_ROOT}/specie/${specie.id}/img?md5=${specie.img_md5 || ""}`
              : null;
          const key = `${componente.id_specie}|${componente.id_serie ?? ''}|${componente.id_varieta ?? ''}`;
          if (counts[key] === undefined) {
            counts[key] = 0;
            ordered.push({ key, img_url, label });
          }
          counts[key]++;
        });

      return ordered.map((entry) => ({
        img_url: entry.img_url,
        label: entry.label,
        count: counts[entry.key],
      }));
    },

    getAvatarVarietaByProdotto(prodotto) {
      const avatari = [];
      (prodotto.componenti || []).forEach((componente) => {
        if (!componente.id_specie) return;
        const specie = this.specie_disponibili.find((item) => item.id === componente.id_specie);
        if (!specie) return;
        const varieta = componente.id_varieta && Array.isArray(specie.variety)
          ? specie.variety.find((item) => item.id === componente.id_varieta)
          : null;
        avatari.push({
          id_varieta: varieta?.id ?? null,
          nome_varieta: varieta?.nome ?? specie.nome,
          img_url: varieta
            ? `${process.env.VUE_APP_API_ROOT}/specie/img_colore/${varieta.id_colore}?t=${varieta.md5_colore || ""}`
            : `${process.env.VUE_APP_API_ROOT}/specie/${specie.id}/img?md5=${specie.img_md5 || ""}`,
        });
      });
      return avatari;
    },
  },
};
